import InfoVideo from "../entities/InfoVideo";
import { AdminRepository } from "../repositories/AdminRepository";

export class GetVideos {
	constructor(private repository: AdminRepository) {}

	execute(): Promise<InfoVideo[]> {
		return this.repository.getVideos();
	}
}
